import type { IconData } from '@stacksjs/iconify-core'

export const userPin: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M35.5 34.384c3.971 1.1 6.5 2.76 6.5 4.616c0 3.313-8.059 6-18 6S6 42.313 6 39c0-1.856 2.528-3.516 6.5-4.616\"/><path d=\"M27.385 15.05a6.5 6.5 0 1 0-6.77 0c-.992.03-1.851.072-2.58.116c-1.913.117-3.566 1.278-4.188 3.09a36 36 0 0 0-1.605 6.91a2.63 2.63 0 0 0 2.13 2.95a49 49 0 0 0 2.752.437l.69 8.612c.109 1.372 1.14 2.494 2.509 2.633c1.06.107 2.368.202 3.677.202s2.617-.095 3.677-.202c1.37-.14 2.4-1.26 2.51-2.633l.689-8.612a49 49 0 0 0 2.751-.437a2.63 2.63 0 0 0 2.131-2.95a36 36 0 0 0-1.605-6.91c-.622-1.812-2.275-2.973-4.188-3.09a85 85 0 0 0-2.58-.116M24 31v9\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default userPin
